import { useEffect, useState } from 'react'
import api from '../../utils/api'
import cookies from '../../utils/cookies'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'
const useUsersApi = () => {
  const addToast = useToastContext()
  const [usersState, setUsersState] = useState({
    data: { users: [] },
    isLoading: false,
    error: null,
  })
  const [invitedUsersState, setInvitedUsersState] = useState({
    data: { invitations: [] },
    isLoading: false,
    error: null,
  })

  const [createUserState, setCreateUserState] = useState({
    isLoading: false,
    error: null,
  })

  const [updateUserState, setUpdateUserState] = useState({
    isLoading: false,
    error: null,
  })

  const [sendInvitationState, setSendInvitationState] = useState({
    isLoading: false,
    error: null,
  })

  const [getUsersFromBuildingState, setGetUsersFromBuildingState] = useState({
    users: [],
    isLoading: false,
    error: null,
  })

  // const [deleteUserState, setDeleteUserState] = useState({
  //   isLoading: false,
  //   error: null,
  // })

  async function createUserDeviceToken(token) {
    const loggedUser = JSON.parse(cookies.get('user'))
    try {
      await api.post(`/users/${loggedUser.id}/deviceTokens`, {
        userId: loggedUser.id,
        deviceId: 'web',
        token,
      })
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al registrar cliente token: ${error?.response?.data?.message}`
      )
    }
  }

  async function getUsers(params) {
    try {
      setUsersState((currentUsersState) => ({
        ...currentUsersState,
        isLoading: true,
        error: null,
      }))
      let url = '/users'
      const response = await api.get(url, { params, includeToken: true })
      setUsersState({
        data: { users: response?.data?.data, count: response?.data?.count },
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setUsersState({ data: null, isLoading: false, error })
    }
  }

  async function getInvitedUsers(params) {
    try {
      setInvitedUsersState((currentInvitedUsersState) => ({
        ...currentInvitedUsersState,
        isLoading: true,
        error: null,
      }))
      let url = '/users/invitations'
      const response = await api.get(url, { params, includeToken: true })
      setInvitedUsersState({
        data: { invitations: response.data.data },
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setInvitedUsersState({ data: null, isLoading: false, error })
    }
  }

  async function createUser(user) {
    let response
    try {
      setCreateUserState((currentCreateUserState) => ({
        ...currentCreateUserState,
        isLoading: true,
        error: null,
      }))
      response = await api.post('/users', user)

      setCreateUserState({
        isLoading: false,
        error: null,
      })
      setUsersState({
        data: Object.assign(
          { ...usersState.data },
          {
            users: [
              ...usersState.data.users,
              {
                ...response.data,
                apartmentId: user.apartmentId,
                buildingId: user.buildingId,
              },
            ],
          }
        ),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Usuario creado con exito!')
      if (user.buildingId) {
        setGetUsersFromBuildingState({
          users: [...getUsersFromBuildingState.users, response.data],
          isLoading: false,
          error: null,
        })
      }
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al crear el usuario: ${error.response.data.message}`
      )
      setCreateUserState({ isLoading: false, error })
    }
  }

  async function updateUser(user, params, isLoggedInUser = false) {
    try {
      setUpdateUserState((currentUpdateUserState) => ({
        ...currentUpdateUserState,
        isLoading: true,
        error: null,
      }))
      const response = await api.put(`/users/${user.id}`, {
        ...user,
        useSignedUrl: true,
      })
      if (isLoggedInUser) {
        cookies.save('user', response.data)
      }
      setUpdateUserState({
        isLoading: false,
        error: null,
      })
      setUsersState({
        data: Object.assign(
          { ...usersState.data },
          {
            users: usersState.data.users.map((elem) => {
              if (elem.id === user.id) {
                delete user.password
                return Object.assign({}, elem, user)
              }
              return elem
            }),
          }
        ),
        isLoading: false,
        error: null,
      })
      if (user.buildingId) {
        setGetUsersFromBuildingState({
          users: getUsersFromBuildingState.users.map((elem) => {
            if (elem.id === user.id) {
              delete user.password
              return Object.assign({}, elem, user)
            }
            return elem
          }),
          isLoading: false,
          error: null,
        })
      }
      addToast(notificationTypes.success, 'Usuario actualizado con exito!')
      await getUsers(params)
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al actualizar el usuario: ${error.response.data.message}`
      )
      setUpdateUserState({ isLoading: false, error })
    }
  }

  async function deleteUser(id) {
    try {
      setUpdateUserState((currentUpdateUserState) => ({
        ...currentUpdateUserState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/users/${id}`)
      setUpdateUserState({
        isLoading: false,
        error: null,
      })
      console.log(usersState.data.users)
      console.log(usersState.data.users.filter((elem) => elem.id !== id))
      console.log(id)
      setUsersState({
        data: Object.assign(
          { ...usersState.data },
          {
            users: usersState.data.users.filter((elem) => elem.id !== id),
          }
        ),
        isLoading: false,
        error: null,
      })
      setGetUsersFromBuildingState({
        users: getUsersFromBuildingState.users.filter((elem) => elem.id !== id),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Usuario borrado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al borrar el usuario: ${error.response.data.message}`
      )
      setUpdateUserState({ isLoading: false, error })
    }
  }

  async function deleteInvitation(id) {
    try {
      setSendInvitationState((currentSendInvitationState) => ({
        ...currentSendInvitationState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/users/${id}`)
      setSendInvitationState({
        isLoading: false,
        error: null,
      })
      setInvitedUsersState({
        data: {
          invitations: invitedUsersState.data.invitations.filter(
            (elem) => elem.id !== id
          ),
        },
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Invitación borrada con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al borrar la invitación: ${error.response.data.message}`
      )
      setUpdateUserState({ isLoading: false, error })
    }
  }

  async function resendInvitation(userId) {
    try {
      setSendInvitationState((currentSendInvitationState) => ({
        ...currentSendInvitationState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/users/${userId}/invitations`)
      setSendInvitationState({
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Invitación reenviada con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al reenviar la invitación: ${error.response.data.message}`
      )
      setSendInvitationState({ isLoading: false, error })
    }
  }

  async function sendInvitations(data) {
    try {
      setSendInvitationState((currentSendInvitationState) => ({
        ...currentSendInvitationState,
        isLoading: true,
        error: null,
      }))
      const response = await api.post(`/users/invitations`, data)
      setSendInvitationState({
        isLoading: false,
        error: null,
      })
      setInvitedUsersState({
        data: {
          invitations: [
            ...invitedUsersState.data.invitations,
            ...response.data,
          ],
        },
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Invitación enviada con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al reenviar la invitación: ${error.response.data.message}`
      )
      setSendInvitationState({ isLoading: false, error })
    }
  }

  // Callers must see a failure: saving a partial list removes the user from the
  // buildings left out, and the API deletes their data there.
  async function getUserApartments(userId) {
    const response = await api.get(`/users/${userId}/apartments`, {
      includeToken: true,
    })
    return response?.data || []
  }

  async function updateUserApartments(userId, apartmentIds) {
    await api.put(`/users/${userId}/apartments`, { apartmentIds }, { includeToken: true })
  }

  async function getUsersFromBuilding(buildingId) {
    try {
      setGetUsersFromBuildingState((currentGetUsersFromBuildingsState) => ({
        ...currentGetUsersFromBuildingsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get(`/buildings/${buildingId}/users`)
      setGetUsersFromBuildingState({
        users: response.data.data,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setGetUsersFromBuildingState({
        users: null,
        isLoading: false,
        error,
      })
    }
  }

  useEffect(() => {
    setUsersState((currentusersState) => ({
      ...currentusersState,
      isLoading: false,
      error: null,
    }))
  }, [])
  const state = {
    usersState,
    createUserState,
    getUsersFromBuildingState,
    invitedUsersState,
  }
  const methods = {
    getUsers,
    createUser,
    updateUser,
    deleteUser,
    getUsersFromBuilding,
    getUserApartments,
    updateUserApartments,
    createUserDeviceToken,
    getInvitedUsers,
    resendInvitation,
    sendInvitations,
    deleteInvitation,
  }
  return [state, methods]
}

export default useUsersApi
